"use client";

import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { fetchProtectedImage } from "@/lib/imageViewer.mjs";

export default function useMediaImageSource(item) {
  const { user } = useAuth();
  const storagePath = item.storagePath || "";
  const [resolved, setResolved] = useState(null);

  useEffect(() => {
    if (!storagePath) return undefined;
    const controller = new AbortController();
    let objectUrl;
    fetchProtectedImage({ storagePath, user, signal: controller.signal })
      .then((blob) => {
        if (controller.signal.aborted) return;
        objectUrl = URL.createObjectURL(blob);
        setResolved({ storagePath, user, signal: controller.signal, src: objectUrl });
      })
      .catch(() => {
        if (!controller.signal.aborted) setResolved({ storagePath, user, signal: controller.signal, src: "" });
      });
    return () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [storagePath, user]);

  if (!storagePath) return { src: item.src || "", loading: false };
  const current = resolved?.storagePath === storagePath && resolved.user === user && !resolved.signal.aborted;
  return { src: current ? resolved.src : "", loading: !current };
}
